<template>
  <model-form
    :model="unknownPayment"
    modal-type="modal"
  >
    <div>
      <div class="row q-gutter-md q-mb-md">
        <q-input
          v-model="unknownPayment.state"
          class="col"
          label="State"
          readonly
        />
        <q-select
          v-model="unknownPayment.handledType"
          :options="unknownPayment.fieldOptions('handledType')"
          class="col"
          label="Handled by"
          emit-value
          :rules="[val => val !== null || 'Field is required']"
        />
      </div>
      <div class="row q-gutter-md q-mb-md">
        <q-input
          v-model="unknownPayment.stripePaymentIntentId"
          class="col"
          label="Stripe Payment Intent"
          readonly
        />
      </div>
      <div class="row q-gutter-md q-mb-md">
        <q-input
          v-model="unknownPayment.notes"
          class="col"
          label="Notes"
          type="textarea"
        />
      </div>
    </div>
  </model-form>
</template>

<script>
import { UNKNOWN_PAYMENT_STATES } from 'src/models/unknown-payment/UnknownPayment'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'UnknownPaymentForm',
  components: {
    ModelForm
  },
  models: {
    unknownPayment: 'default'
  },
  watch: {
    'unknownPayment.handledType': function () {
      if (this.unknownPayment.handledType) {
        this.unknownPayment.state = UNKNOWN_PAYMENT_STATES.HANDLED
      }
    }
  }
}

</script>
